import { Component } from '@angular/core';

@Component({
  selector: 'app-sponsors-component',
  imports: [],
  templateUrl: './sponsors-component.html',
  styleUrl: './sponsors-component.scss'
})
export class SponsorsComponent {

}
